import { useBreakpoints } from '@cbhq/cds-web/hooks/useBreakpoints';
import { Box, HStack, VStack } from '@cbhq/cds-web/layout';

type TwoColumnLayoutProps = {
  primaryContent: React.ReactElement;
  secondaryContent?: React.ReactElement;
};

export function TwoColumnLayout({ primaryContent, secondaryContent }: TwoColumnLayoutProps) {
  const { isDesktop } = useBreakpoints();

  return (
    <HStack spacingTop={5} flexWrap={isDesktop ? 'nowrap' : 'wrap'} gap={3}>
      <VStack flexGrow={1} alignItems="center" overflow="hidden">
        <Box maxWidth={750} width="100%" spacingHorizontal={2}>
          {primaryContent}
        </Box>
      </VStack>
      <VStack flexGrow={1} flexBasis={0} minWidth={410} alignItems="center">
        <Box maxWidth={675} width="100%" spacingHorizontal={2}>
          {secondaryContent}
        </Box>
      </VStack>
    </HStack>
  );
}
